import { drawRoundedPolygon, sizeOptionsOrDefault } from './utils';
import { MultiPathShape } from './MultiPathShape';
const defaultOptions = {
    leftLineOffsetRatio: 0.13,
    topLineOffsetRatio: 0.23,
};
/**
 * Represents an Internal Storage shape, a flowchart element used to indicate
 * internal storage or memory operations. Extends MultiPathShape with a rectangle
 * containing internal dividing lines.
 */
export class InternalStorage extends MultiPathShape {
    /**
     * Creates a new InternalStorage instance.
     * @param options - Configuration options for the internal storage shape
     */
    constructor(options) {
        super({ ...defaultOptions, ...options });
    }
    /**
     * @hidden
     * Draws the internal storage shape path as a rectangle with internal lines.
     */
    _drawPath() {
        const drawingElement = this.drawingElement;
        const { width, height } = sizeOptionsOrDefault(this.options);
        const { leftLineOffsetRatio, topLineOffsetRatio } = this.options;
        const leftLineX = width * leftLineOffsetRatio;
        const topLineOffset = height * topLineOffsetRatio;
        const points = [
            { x: 0, y: 0 },
            { x: width, y: 0 },
            { x: width, y: height },
            { x: 0, y: height }
        ];
        drawRoundedPolygon(drawingElement, points, this.options.cornerRadius);
        drawingElement
            .moveTo(leftLineX, 0)
            .lineTo(leftLineX, height)
            .moveTo(0, topLineOffset)
            .lineTo(width, topLineOffset);
    }
}
